import { generateLabelsAndValues } from "../utils/helperFunctions";

export const TypeOfAudience = {
  PROFESSIONAL_TECHNOLOGISTS: 1,
  CERTIFIED_TECHNICIANS: 2,
  OPEN_FOR_ALL: 3,
  GENERAL_AUDIENCE: 4
};

export const TypeOfCPDTaregetAudience = generateLabelsAndValues(TypeOfAudience);
